export default "__VITE_ASSET__Csx6U9$x__"